var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-container',{attrs:{"fluid":"","tyle":"margin: 0px; padding: 0px; width: 50%"}},[_c('hmi-reguladores1'),_c('hmi-reguladores2')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }